import { LAYOUTS, ModalAlignmentEnum, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { heightMap } from '../../configs/height';
import { ACTION } from "./types";
import { onClosePopup, onShareLink, onTrackCustomerJourney } from "./actions";
import { partnerDetailsDSBuilder, returnDateInString } from "./utils";
import { addCommasToNumber, isMobile, maskSensitiveDetails, showMFDLedJourney, showPhoneNumber } from "../../configs/utils";
import { getEpochTime } from "../partnerWeb_Dashboard/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { showShareLink } from "../../configs/uri-config-utils";
const _isMobile = isMobile();
export const template = async (FieldsObject, user, customerName, customerPhoneNumber, activeCustomer, partnerAccountType, partnerUserContext) => ({
    layout: {
        id: ROUTE.PARTNER_VIEW_DETAIL_LEAD,
        type: LAYOUTS.MODAL,
        style: _isMobile ? {
            isPartnerPlatform: true,
            height: heightMap[ROUTE.PARTNER_VIEW_DETAIL_LEAD],
        } : {
            //@ts-ignore
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.RIGHT,
            height: 400
        },
        widgets: [
            { id: 'partnerViewDetailsLeadsHeader', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            { id: 'partnerViewDetailsLeadsBody', type: WIDGET.STACK },
            { id: 'partnerViewDetailsLeadsFooter', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM },
        ],
    },
    datastore: {
        partnerViewDetailsLeadsHeader: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'partnerViewDetailsLeadsHeaderTopStack', type: WIDGET.STACK },
                { id: 'partnerViewDetailsLeadsHeaderBottomStack', type: WIDGET.STACK },
                { id: 'partnerViewDetailsLeadsHeaderDivider', type: WIDGET.DIVIDER }
            ]
        },
        partnerViewDetailsLeadsHeaderDivider: {
            size: DividerSizeTokens.MD,
            color: ColorTokens.Grey_Chalk
        },
        partnerViewDetailsLeadsHeaderTopStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'partnerViewDetailsLeadsHeader_TopStackT1', type: WIDGET.TEXT },
                { id: 'partnerViewDetailsLeadsHeader_CloseIcon', type: WIDGET.ICON },
            ]
        },
        partnerViewDetailsLeadsHeader_TopStackT1: {
            label: `${customerName ?
                customerName :
                showPhoneNumber(partnerAccountType) ?
                    customerPhoneNumber :
                    `+91${maskSensitiveDetails(`${customerPhoneNumber}`.slice(3), 0, 3)}`}`,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        partnerViewDetailsLeadsHeader_CloseIcon: {
            name: IconTokens.Cross,
            color: ColorTokens.Grey_Night,
            size: IconSizeTokens.XXXL,
            action: {
                routeId: ROUTE.PARTNER_VIEW_DETAIL_LEAD,
                type: ACTION.CLOSE_POPUP,
                payload: {}
            }
        },
        partnerViewDetailsLeadsHeaderBottomStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL
            },
            widgetItems: [
                customerName ? { id: 'partnerViewDetailsLeadsHeaderBottomStackT1', type: WIDGET.TEXT } : {}
            ]
        },
        partnerViewDetailsLeadsHeaderBottomStackT1: {
            label: `${customerPhoneNumber ? showPhoneNumber(partnerAccountType) ?
                customerPhoneNumber :
                `+91${maskSensitiveDetails(`${customerPhoneNumber}`.slice(3), 0, 3)}` : ''}`,
            fontWeight: '400',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Night,
            lineHeight: 24,
        },
        partnerViewDetailsLeadsBody: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL
            },
            widgetItems: partnerDetailsDSBuilder(FieldsObject).WIDGET_STORE
        },
        ...partnerDetailsDSBuilder(FieldsObject).DATA_STORE,
        partnerViewDetailsLeadsFooter: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            padding: {
                all: SizeTypeTokens.XL
            },
            widgetItems: [
                activeCustomer ? {} : showShareLink(partnerUserContext) ? { id: 'partnerViewDetailsLeadsFooter_shareLinkBtnStack', type: WIDGET.STACK } : {},
                activeCustomer ? {} : showShareLink(partnerUserContext) ? { id: 'partnerViewDetailsLeadsFooterSpace0', type: WIDGET.SPACE } : {},
                showMFDLedJourney(partnerAccountType) ? { id: 'partnerViewDetailsLeadsFooter_assistedJourneyBtnStack', type: WIDGET.STACK } : {}
            ]
        },
        partnerViewDetailsLeadsFooter_shareLinkBtnStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'partnerViewDetailsLeadsFooter_shareLinkBtn', type: WIDGET.BUTTON }
            ]
        },
        partnerViewDetailsLeadsFooter_assistedJourneyBtnStack: {
            type: StackType.row,
            flex: 1,
            widgetItems: [
                { id: 'partnerViewDetailsLeadsFooter_assistedJourneyBtn', type: WIDGET.BUTTON }
            ]
        },
        partnerViewDetailsLeadsFooter_shareLinkBtn: {
            type: ButtonTypeTokens.MediumSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Share link',
            action: {
                routeId: ROUTE.PARTNER_VIEW_DETAIL_LEAD,
                type: ACTION.SHARE_LINK,
                payload: {
                    value: user
                }
            }
        },
        partnerViewDetailsLeadsFooter_assistedJourneyBtn: {
            type: ButtonTypeTokens.MediumFilled,
            width: ButtonWidthTypeToken.FULL,
            label: activeCustomer ? 'View as client' : 'Complete application',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            action: {
                routeId: ROUTE.PARTNER_VIEW_DETAIL_LEAD,
                type: ACTION.ON_TRACK_CUSTOMER_JOURNEY,
                payload: {
                    value: user
                }
            }
        },
        partnerViewDetailsLeadsFooterSpace0: {
            size: SizeTypeTokens.XL
        }
    },
});
export const partnerViewDetailLeads = {
    onLoad: async ({ asyncStorage, setDatastore }, { user, leads, activeCustomer }) => {
        let _FieldsObject = {};
        await AsyncStorage.setItem("pljName", "");
        if (user?.borrowerAccountProfile?.name) {
            await AsyncStorage.setItem("pljName", user?.borrowerAccountProfile?.name);
        }
        if (leads) {
            _FieldsObject = {
                "Last update": `${returnDateInString(user?.creditApplication.lastUpdatedOn)} ${getEpochTime(user?.creditApplication.lastUpdatedOn)}`,
                "Created date": `${returnDateInString(user?.creditApplication.createdOn)} ${getEpochTime(user?.creditApplication.createdOn)}`,
                "Status": `${user.currentStepName ? user.currentStepName : ''}`,
                "Fetched portfolio": `₹${addCommasToNumber(user?.assetDetails.totalPortfolioAmount | 0)}`,
                "Available credit limit": `₹${addCommasToNumber(user?.assetDetails.availableCreditAmount | 0)}`,
                "Pledged portfolio": `₹${addCommasToNumber(user?.assetDetails?.pledgedPortfolioAmount | 0)}`,
                "Pledged credit limit": `₹${addCommasToNumber(user?.assetDetails?.approvedCreditAmount | 0)}`,
            };
        }
        if (activeCustomer) {
            _FieldsObject = {
                "Available credit limit": `${addCommasToNumber(user?.credit?.availableCreditAmount | 0)}`,
                "Total credit limit": `₹${addCommasToNumber(user?.credit.approvedCreditAmount | 0)}`,
                "Portfolio pledged": `₹${addCommasToNumber(user?.credit?.totalValueOfAssetsPledged | 0)}`,
                "Outstanding amount": `₹${addCommasToNumber(user?.credit?.principalOutStandingAmount | 0)}`,
                "Interest rate": `${user?.credit?.currentApplicableInterestRate} %`,
                "Created date": `${returnDateInString(user?.creditApplication.createdOn)} ${getEpochTime(user?.creditApplication.createdOn)}`
            };
        }
        const _user = JSON.parse(await AsyncStorage.getItem(StoreKey.userContext));
        const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
        const customerName = user?.borrowerAccountProfile?.name;
        const customerPhoneNumber = user?.borrowerAccountProfile?.phoneNumber;
        return Promise.resolve(template(_FieldsObject, user, customerName, customerPhoneNumber, activeCustomer, partnerAccountType, _user));
    },
    actions: {
        [ACTION.CLOSE_POPUP]: onClosePopup,
        [ACTION.SHARE_LINK]: onShareLink,
        [ACTION.ON_TRACK_CUSTOMER_JOURNEY]: onTrackCustomerJourney
    },
};
